import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Los kits son digitales?',
  a: 'Sí, todos nuestros kits son 100% digitales. Una vez realizado el pago, recibís acceso inmediato a todo el material en tu correo electrónico para descargarlo o verlo online.'
}, {
  q: '¿Puedo verlos desde el celular?',
  a: '¡Totalmente! El material está diseñado para verse perfecto en celulares, tablets y computadoras. Podés llevar tus recetas y listas de compras al supermercado en tu teléfono.'
}, {
  q: '¿Necesito saber cocinar?',
  a: 'No. Las recetas están pensadas para personas con poco tiempo y sin experiencia previa. Son fáciles, rápidas y con ingredientes que conseguís en cualquier supermercado o dietética.'
}, {
  q: '¿Puedo comprar más de un kit?',
  a: 'Sí, podés elegir un kit principal y luego agregar los complementos que necesites desde la sección de "Potenciá tu kit". Todo se sumará a tu carrito con un descuento especial.'
}, {
  q: '¿Cómo recibo el acceso?',
  a: 'Inmediatamente después de confirmar el pago, el sistema te envía un correo automático con tu usuario y contraseña para acceder a la plataforma donde está todo tu material.'
}, {
  q: '¿Qué medios de pago puedo usar?',
  a: 'Podés pagar de forma 100% segura con Mercado Pago, y también con tarjetas Visa, Mastercard y American Express (crédito y débito). Elegís el medio que más te convenga al momento de finalizar tu compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream-dark" data-id="element-332">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-333">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-334">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-ink" data-id="element-335">
            Preguntas Frecuentes
          </h2>
        </motion.div>
        <div className="space-y-4" data-id="element-336">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-sm border border-ink/5 overflow-hidden" data-id="element-337">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-338">
                  <span className="font-bold text-ink pr-8" data-id="element-339">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-ink-light transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-340" />
                </button>
                <AnimatePresence data-id="element-341">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-342">
                      <div className="px-6 pb-5 text-ink-light leading-relaxed" data-id="element-343">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}